import { routesTemplate } from "../routesTemplate";

import MuralScreen from "../../screens/mural/MuralScreen";
import PostWriteScreen from "../../screens/mural/PostWriteScreen";
import CommentsScreen from "../../screens/mural/CommentsScreen";
import CommentWriteScreen from "../../screens/mural/CommentWriteScreen";

export const muralStack = [
    routesTemplate('/mural', MuralScreen, "Mural"),
    routesTemplate('/mural/post', PostWriteScreen),
    routesTemplate('/mural/comments', CommentsScreen),
    routesTemplate('/mural/comments/post', CommentWriteScreen),
];

